<div class="ccm_usage">
    <div class="spinner-content" *ngIf="loading">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
    <div class="ccm_usage_left full_width">
        <h4 *ngIf="!loading">Age at Diagnosis</h4>
        <p [innerHTML]="dataInsight?.diagnosis_text | safeHtml" *ngIf="!loading"></p>
        <div class="canvas">
            <canvas id="ageDiagnosisChart" height="400" width="650"></canvas>
        </div>

    </div>

</div>